var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListViewAll = function SvgListViewAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M19.215 3C20.2 3 21 3.8 21 4.785v3.608c0 .986-.8 1.785-1.785 1.785H4.785C3.8 10.178 3 9.378 3 8.393V4.785C3 3.8 3.8 3 4.785 3zm1.1 1.785a1.1 1.1 0 0 0-1.1-1.1H4.785a1.1 1.1 0 0 0-1.1 1.1v3.608a1.1 1.1 0 0 0 1.1 1.1h14.43a1.1 1.1 0 0 0 1.1-1.1zM19.215 13.822c.986 0 1.785.8 1.785 1.785v3.608C21 20.2 20.2 21 19.215 21H4.785C3.8 21 3 20.2 3 19.215v-3.608c0-.986.8-1.785 1.785-1.785zm1.1 1.785a1.1 1.1 0 0 0-1.1-1.1H4.785a1.1 1.1 0 0 0-1.1 1.1v3.608a1.1 1.1 0 0 0 1.1 1.1h14.43a1.1 1.1 0 0 0 1.1-1.1z",
    clipRule: "evenodd"
  })));
};
export default SvgListViewAll;